export default "__VITE_ASSET__vNuZgzjq__"